import { PureComponent } from "react"
import enhanceWithClickOutside from "react-click-outside"
import SelectDropdownItem from "./select-dropdown-item"

class SelectDropdownList extends PureComponent {
  handleClickOutside = (e) => {
    e.stopPropagation()
    this.props.toggleOpen(false)
  }

  changeOption = ({ forLabel, value }) => {
    this.props.changeOption({
      forLabel: forLabel,
      value,
    })
  }

  render() {
    const { options, forLabel, customLabel } = this.props

    return (
      <ul>
        {options.map((option) => {
          return (
            option.itemId !== 0 && (
              <SelectDropdownItem
                key={option.itemId}
                onClick={this.changeOption}
                {...option}
                forLabel={forLabel}
                disabled={this.props.disabled}
                customLabel={option[customLabel]}
              />
            )
          )
        })}
      </ul>
    )
  }
}

SelectDropdownList.propTypes = {}

export default enhanceWithClickOutside(SelectDropdownList)
